/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_CnpjInputs */

const en_clients_validation_cnpj = /** @type {(inputs: Clients_Validation_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid CNPJ.`)
};

const pt_br2_clients_validation_cnpj = /** @type {(inputs: Clients_Validation_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um CNPJ válido.`)
};

/**
* | output |
* | --- |
* | "Enter a valid CNPJ." |
*
* @param {Clients_Validation_CnpjInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_cnpj = /** @type {((inputs?: Clients_Validation_CnpjInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_CnpjInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_cnpj(inputs)
	return pt_br2_clients_validation_cnpj(inputs)
});